module.exports = __webpack_public_path__ + "static/media/left-arrow-svgrepo-com.3f7d4a72.svg";